export default "__VITE_ASSET__DptRC08X__"